import router from '@landingPage/router/landingpage.router';
import store from '@landingPage/store/index';
import i18n from '@landingPage/static/i18n/index';

export default {
    i18n,
    store,
    router
};
